import { z } from 'zod';
import { CoreCommunicationSocialMediaIntegrationStatusSchema } from '../inputTypeSchemas/CoreCommunicationSocialMediaIntegrationStatusSchema'

/////////////////////////////////////////
// CORE COMMUNICATION SOCIAL MEDIA INTEGRATION SCHEMA
/////////////////////////////////////////

export const CoreCommunicationSocialMediaIntegrationSchema = z.object({
  status: CoreCommunicationSocialMediaIntegrationStatusSchema,
  id: z.bigint(),
  cityId: z.number().int(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  deactivatedAt: z.coerce.date().nullable(),
  deletedAt: z.coerce.date().nullable(),
  accountName: z.string().nullable(),
  adminNotes: z.string().nullable(),
  accountProfileImageFileId: z.number().int().nullable(),
})

export type CoreCommunicationSocialMediaIntegration = z.infer<typeof CoreCommunicationSocialMediaIntegrationSchema>

export default CoreCommunicationSocialMediaIntegrationSchema;
